import { z } from "zod";

const EvidenceStrengthEnum = z.enum([
  "none",
  "weak",
  "medium",
  "strong",
  "contradicting_weak",
  "contradicting_medium",
  "contradicting_strong"
]);

const ClaimEvidenceSchema = z.object({
  sourceType: z.enum(["document", "url"]),
  sourceId: z.string(),
  sourceCitedInMemo: z.string().nullable(),
  evidenceStrength: EvidenceStrengthEnum,
  verbatimText: z.string(),
  reasoning: z.string(),
  sourceMatchesMemo: z.boolean()
});

const ClaimCommentSchema = z.object({
  id: z.number(),
  content: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  user: z.object({
    id: z.number(),
    firstName: z.string(),
    lastName: z.string(),
    profileImageUrl: z.string().nullable()
  })
});

const ClaimReviewReasonEnum = z.enum(["not_applicable", "closed"]);

const ClaimSchema = z.object({
  id: z.coerce.number().optional(),
  claim: z.string(),
  claimMarkdown: z.string(),
  sourceCitedInMemo: z.string().nullable(),
  detectedSourceType: z.string().nullish(),
  detectedSourceId: z.string().nullish(),
  isReviewed: z.boolean().optional(),
  isReviewedButFrozen: z.boolean().optional(),
  reviewedAt: z.coerce.date().nullable(),
  reviewedReason: ClaimReviewReasonEnum.nullable().optional(),
  reviewedReasonButFrozen: ClaimReviewReasonEnum.nullable().optional(),
  createdAt: z.coerce.date().optional(),
  evidenceStrength: EvidenceStrengthEnum,
  evidenceReasoning: z.string().nullable(),
  evidence: z.array(ClaimEvidenceSchema),
  comments: z.array(ClaimCommentSchema)
});

export const GetClaimsSchema = z.object({
  claims: z.array(ClaimSchema),
  chapterUpdatedAt: z.coerce.date()
});

export type TClaims = z.infer<typeof GetClaimsSchema>;
export type TClaim = z.infer<typeof GetClaimsSchema>["claims"][number];
export type TClaimEvidence = z.infer<typeof ClaimEvidenceSchema>;
export type TClaimComment = z.infer<typeof ClaimCommentSchema>;
export type TClaimReviewReason = z.infer<typeof ClaimReviewReasonEnum>;

export type TViewMode = "claim" | "evidence";
export type TClaimTab = "red" | "yellow" | "green" | "reviewed";
export type TPreparedClaim = TClaim & {
  status: string;
  rationale: string;
  styles: string;
};
